<template>
  <div id="reset" v-bind:class="{ loading: loading }" class="resetPassword">
    <div class="header">
        <p></p>
    </div>
		<div class="loginForm" v-if="!sent">
      <h1>Reset Password</h1>
      <div class="input">
          <input type="text" required v-model="email" placeholder="Email">
          <label class="sr-only">Email</label>
      </div>
      <button class="btn submitBtn" v-bind:class="{ loading: loading }" @click="resetAccount">Reset</button>
    </div>
		<div class="loginForm" v-if="sent">
      <h1>Reset Password Token</h1>
      <div class="input">
          <input type="text" required v-model="token" placeholder="Token">
          <label class="sr-only">Token</label>
      </div>
      <div class="input">
          <input type="password" required v-model="password" placeholder="Password">
          <label class="sr-only">Password</label>
      </div>
      <div class="input">
          <input type="password" required v-model="password_confirm" placeholder="Password Confirm">
          <label class="sr-only">Confirm Password</label>
      </div>
      <button class="btn submitBtn" v-bind:class="{ loading: loading }" @click="resetWithToken">Update</button>
    </div>
    <button class="btn backBtn"  @click="$router.push({ path: '/login' })"><i class="icon-left-open"></i>Back to Login</button>
  </div>
</template>

<script>
import {mapActions} from 'vuex'

export default {
  name: 'reset-password',
  data: function () {
    return {
      email: '',
      token: '',
      sent: false,
      password: '',
      password_confirm: '',
      loading: false
    }
  },
  methods: {
    resetWithToken () {
      this.loading = true

      this.resetByToken({
        email: this.email,
        token: this.token,
        password: this.password
      })
        .then(response => {
          window.alertify.success('Password Updated.')
          this.$router.push('/login')
        })
        .catch(error => {
          window.alertify.error(error.message)
          this.sent = false
          this.loading = false
          this.token = ''
          this.password = ''
          this.password_confirm = ''
        })
    },
    resetAccount () {
      console.log(this.$store)
      this.loading = true
      this.resetByEmail(this.email)
        .then(response => {
          this.sent = true
          this.loading = false
        })
    },
    ...mapActions([
      'resetByEmail',
      'resetByToken'
    ])
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/login/ResetPassword.vue